import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { api } from "@api/api";
import { ApiError } from "@shared/types";
import {
  GenerateMonthlyPayload,
  GenerateMonthlyResponse,
} from "@modules/partners/types";

export function useGenerateMonthlyMutation() {
  const translate = useTranslate();
  const { open } = useNotification();
  const queryClient = useQueryClient();

  return useMutation<GenerateMonthlyResponse, ApiError, GenerateMonthlyPayload>({
    mutationFn: async (payload) => {
      const { data } = await api.post<GenerateMonthlyResponse>(
        "/v1/partner_monthly_generate_admin/",
        payload
      );
      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ["v1/partner_monthly_admin"],
        refetchType: "all",
      });
      open?.({
        type: "success",
        message: translate("v1/partner_monthly_admin.success.generate", {
          taskId: data.task_id,
        }),
      });
    },
    onError: (error: ApiError) => {
      open?.({ type: "error", message: error.response.data.error });
    },
  });
}
